// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2tDZ_","content":"RecentSearches_content__R5GPY"};